import { useAuth } from "@/hooks/useAuth";

/**
 * DemoModeBanner — a permanent strip while you're inside the demo account.
 *
 * Mounted app-wide and renders nothing for real users (`isDemo` is false on
 * every account that isn't the seeded one).
 *
 * WHY IT DOESN'T DISMISS
 * ----------------------
 * Every other banner in this app can be closed, because every other banner is
 * telling you about something you can act on. This one is telling you which
 * account you are in — and the moment it's gone, a leader poking around for
 * ten minutes has no way of knowing whether the journal entry he just typed is
 * his, someone else's, or about to be deleted at 3am.
 *
 * A dismissible version was the obvious first instinct and it's the wrong one:
 * the cost of the strip is a few pixels on every screen, and the cost of
 * dismissing it is someone writing something real into an account that gets
 * wiped nightly.
 */
export default function DemoModeBanner() {
  const { user } = useAuth();
  if (!user?.isDemo) return null;

  return (
    <div
      className="w-full bg-amber-600 px-3 py-1.5 text-center text-xs font-medium text-white"
      style={{ paddingTop: "calc(0.375rem + env(safe-area-inset-top, 0px))" }}
      role="status"
    >
      Demo account — everything here is made up, and it resets overnight.
    </div>
  );
}
